import React, { useState } from 'react';

export default function RoomHeader({ roomMeta, setRoomMeta, isHost, roomRecordId, pb }) {
  const [isEditingMeta, setIsEditingMeta] = useState(false);

  const handleSave = async () => {
    setIsEditingMeta(false);
    if (roomRecordId) {
      await pb.collection('rooms').update(roomRecordId, roomMeta);
    }
  };

  return (
    <div style={{ marginBottom: '20px' }}>
      {isEditingMeta && isHost ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '10px' }}>
          <input 
            type="text" 
            value={roomMeta.title} 
            onChange={(e) => setRoomMeta({ ...roomMeta, title: e.target.value })} 
            style={{ fontSize: '24px', fontWeight: 'bold', padding: '5px', width: '100%' }} 
          />
          <input 
            type="text" 
            value={roomMeta.description} 
            placeholder="Add a brief description..." 
            onChange={(e) => setRoomMeta({ ...roomMeta, description: e.target.value })} 
            style={{ fontSize: '14px', padding: '5px', width: '100%' }} 
          />
          <button 
            onClick={handleSave}
            style={{ padding: '6px 12px', background: '#5cb85c', color: 'white', border: 'none', borderRadius: '4px', width: '100px', cursor: 'pointer' }}
          >
            Save
          </button>
        </div>
      ) : (
        <div>
          <h2 style={{ margin: '0 0 5px 0' }}>
            {roomMeta.title}
            {isHost && (
              <span 
                onClick={() => setIsEditingMeta(true)} 
                style={{ fontSize: '12px', color: '#0275d8', cursor: 'pointer', marginLeft: '10px', fontWeight: 'normal' }}
              >
                (Edit)
              </span>
            )}
          </h2>
          <p style={{ margin: '0', color: '#666', fontSize: '14px' }}>
            {roomMeta.description || 'No description provided.'}
          </p>
        </div>
      )}
    </div>
  );
}